var AccOrdersPage = {};

AccOrdersPage.init = function () {
  $('.orders_table').each(function (i, el) {
    new OrderTable(el);
  });
};

$(AccOrdersPage.init);

function OrderTable(element) {
  var $el = $(element);
  var currentRow = null;
  //create rows
  $el.find('.table-body > .item').each(function (i, rowElement) {
    var row = new ClientOrderRow(rowElement, {
      onOpen: function () {
        currentRow = row;
        updateActionButtons(row);
      },
      updateActionButtons: updateActionButtons
    });
  }.bind(this));
  var returnForm = $el.find('form[name="returnForm"]');
  var complaintsForm = $el.find('form[name="complaintsForm"]');
  $el.find('button.return').click(function () {
    returnForm.find('input').val(JSON.stringify(currentRow.selected));
    returnForm.submit();
  });
  $el.find('button.complaint').click(function () {
    complaintsForm.find('input').val(JSON.stringify(currentRow.selected));
    complaintsForm.submit();
  });

  function updateActionButtons(row) {
    var allReturn = true;
    var canComplaint = true;
    if (row.selected.length === 0) {
      $el.find('button.return').hide();
      $el.find('button.complaint').hide();
      return;
    }
    row.selected.forEach(function (id) {
      var orderItem = row.items[id].orderItem;
      if (!orderItem.canComplaint) {
        canComplaint = false;
      }
      if (!orderItem.canReturn) {
        allReturn = false;
      }
    }, row);
    if (allReturn) {
      $el.find('button.return').show();
    } else {
      $el.find('button.return').hide();
    }
    if (canComplaint) {
      $el.find('button.complaint').show();
    } else {
      $el.find('button.complaint').hide();
    }
  }
}

function ClientOrderRow(element, conf) {
  this.$el = $(element);
  this.selected = [];
  this.items = {};
  this.order = {
    _id: element.getAttribute("data-id")
  };
  this.$el.find('.expand').click(function () {
    conf.onOpen && conf.onOpen(this);
  }.bind(this));
  this.$el.find("[data-order-item-id]").each(function (i, itemElement) {
    var item = new ClientOrderItemRow(itemElement);
    item.onSelected = function (selected) {
      if (selected) {
        this.selected.push(item.orderItem.orderItemId);
      } else {
        var index = this.selected.indexOf(item.orderItem.orderItemId);
        this.selected.splice(index, 1);
      }
      conf.updateActionButtons && conf.updateActionButtons(this);
    }.bind(this);
    this.items[item.orderItem.orderItemId] = item;
  }.bind(this));
}

function ClientOrderItemRow(element) {
  this.$el = $(element);
  this.orderItem = this.$el.data();
  if (this.orderItem.canReturn || this.orderItem.canComplaint) {
    this.$el.find('input[type="checkbox"]').change(function (evt) {
      this.onSelected && this.onSelected(evt.currentTarget.checked);
    }.bind(this));
  }
}